

// Components
import Heading from '@/components/atoms/Heading/Heading';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';
import Markdown from '@/components/atoms/Markdown/Markdown';
import CmsImage from '@/components/atoms/CmsImage/CmsImage';

// Other
import { type SectionRecyclageType } from '@/services/blocksSchema';

// Style
import styles from './SectionRecyclage.module.css';

interface SectionRecyclageProps {
  preTitle: SectionRecyclageType['preTitle'];
  title: SectionRecyclageType['title'];
  description: SectionRecyclageType['description'];
  logo: SectionRecyclageType['logo'];
  image: SectionRecyclageType['image'];
}

function SectionRecyclage({
  preTitle,
  title,
  description,
  logo,
  image,

}: SectionRecyclageProps) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles['card-body']}>
          <div className={styles['card-content']}>
            <div className={styles['card-header']}>
              <PreTitle
                preTitle={preTitle}
                size='p1'
                color='light'
              />
              <Heading
                title={title}
                size='h2'
                Tag='h2'
                color='light'
              />
            </div>
            <Markdown
              text={description}
              className={styles['card-description']}
            />
          </div>
          <div className={styles['card-image-block']}>
            <CmsImage
              media={image}
              sizes="(max-width: 1024px) 100vw, 400px"
              className={styles['card-image']}
            />
          </div>
        </div>
        <div
          className={styles['card-logo']}  
        >
          <CmsImage
            media={logo}
            sizes="(max-width: 1024px) 100vw, 250px"
          />
        </div>
      </div>
    </div>
  );
}

export default SectionRecyclage;
